import React from 'react';
import { LoveMeter } from '../../LoveMeter';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import LiteratureContent from '../../LiteratureContent';
import DesktopLayout from '../_partials/DesktopLayout';
import StageBackground from '../../DeviationBackground/StageBackground';
import PanelPopup from '..//_partials/PanelPopup';
import s from './DesktopLiteraturePage.scss';
export var DesktopLiteraturePage = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, loveScore = _b.loveScore, deviationId = _b.deviationId;
    return (React.createElement(DesktopLayout, { deviation: deviation, stageContent: React.createElement(LoveMeter, { itemId: deviationId, initialData: { loveScore: loveScore }, supportsRecommendations: true },
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement("div", { className: s['lit-content'] },
                React.createElement(ActionBar, { deviation: deviation })),
            React.createElement(PanelPopup, { deviation: deviation, className: s['large-popover'], actionBarType: "primary" }),
            React.createElement("div", { className: s['lit-content'] },
                React.createElement(LiteratureContent, { deviation: deviation }))), metaContent: React.createElement(Details, { className: s['details'], deviation: deviation }), backgroundContent: React.createElement(StageBackground, { deviation: deviation }), withSecondaryActionBar: true }));
};
DesktopLiteraturePage.displayName = 'DesktopLiteraturePage';
export default DesktopLiteraturePage;
//# sourceMappingURL=DesktopLiteraturePage.js.map